import { SkillUploadDialog } from "@/components/SkillUploadDialog/SkillUploadDialog";
import { useOpenSkill } from "@/panes/skill/useOpenSkill";
import { useCallback, useState } from "react";

/** Shared create / upload-zip actions for the skills rail header and zero state. */
export function useSkillsRailAddActions() {
  const openSkill = useOpenSkill();
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  const createFromScratch = useCallback(() => {
    openSkill("new");
  }, [openSkill]);

  /** Defer open so DropdownMenu can finish unmounting; avoids body stuck with pointer-events: none (Radix #3317). */
  const openUploadZipDialog = useCallback(() => {
    window.setTimeout(() => setUploadDialogOpen(true), 0);
  }, []);

  const onUploadSuccess = useCallback(
    (skill: { id: string }) => {
      openSkill(skill.id);
    },
    [openSkill],
  );

  const uploadZipDialog = (
    <SkillUploadDialog
      open={uploadDialogOpen}
      onOpenChange={setUploadDialogOpen}
      onSuccess={onUploadSuccess}
    />
  );

  return {
    createFromScratch,
    openUploadZipDialog,
    uploadZipDialog,
  };
}
